// src/pages/MentionsLegales.js
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import SectionTitle from '../components/ui/SectionTitle';
import { fadeIn } from '../styles/animations';

const LegalPageWrapper = styled.div`
  padding-top: 80px; // Pour compenser la hauteur du header fixe
`;

const HeroSection = styled.section`
  position: relative;
  height: 30vh;
  min-height: 250px;
  max-height: 400px;
  overflow: hidden;
  padding: 0;
  background-color: ${props => props.theme.colors.primary};
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.2));
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  color: ${props => props.theme.colors.light};
  z-index: 2;
  text-align: center;
  animation: ${fadeIn} 0.8s ease-out forwards;
`;

const HeroTitle = styled.h1`
  color: ${props => props.theme.colors.light};
  margin-bottom: ${props => props.theme.spacing.md};
  font-size: ${props => props.theme.fontSizes.xxxl};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxl};
  }
`;

const Section = styled.section`
  padding: ${props => props.theme.spacing.xl} 0;
  background-color: ${props => props.bgColor || props.theme.colors.light};
`;

const SectionContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
`;

const LegalContent = styled.div`
  animation: ${fadeIn} 0.8s ease-out forwards;
  
  h2 {
    color: ${props => props.theme.colors.primary};
    margin-top: ${props => props.theme.spacing.lg};
    margin-bottom: ${props => props.theme.spacing.md};
    font-size: ${props => props.theme.fontSizes.xl};
  }
  
  p {
    margin-bottom: ${props => props.theme.spacing.md};
    line-height: 1.7;
  }
  
  ul {
    padding-left: 1.5rem;
    margin-bottom: ${props => props.theme.spacing.md};
    
    li {
      margin-bottom: ${props => props.theme.spacing.sm};
      line-height: 1.7;
    }
  }
`;

const MentionsLegales = () => {
    return (
        <LegalPageWrapper>
            <Helmet>
                <title>Mentions Légales - Decko | Créateur de vos parquets de jardin</title>
                <meta name="description" content="Mentions légales de Decko, spécialiste des terrasses en bois et parquets de jardin depuis 1985." />
            </Helmet>

            <HeroSection>
                <HeroContent>
                    <HeroTitle>Mentions Légales</HeroTitle>
                </HeroContent>
            </HeroSection>

            <Section>
                <SectionContainer>
                    <LegalContent>
                        <h2>1. Éditeur du site</h2>
                        <p>Le site Decko.fr est édité par :</p>
                        <ul>
                            <li>DECKO - SARL d'Olivier Diard</li>
                            <li>SIRET : 47938377000019</li>
                            <li>Siège social : 15, rue du Moulin des Ratelles, 44690 LA HAYE FOUASSIÈRE</li>
                            <li>Email : contact@decko.fr</li>
                            <li>Hébergeur : OVH</li>
                        </ul>

                        <h2>2. Activité</h2>
                        <p>Decko.fr est un site vitrine présentant les services de construction de terrasses en bois proposés par la société DECKO. Il permet également aux visiteurs de contacter l'entreprise.</p>

                        <h2>3. Propriété intellectuelle</h2>
                        <p>L'ensemble du contenu du site (textes, images, logos, etc.) est protégé par le droit d'auteur. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>

                        <h2>4. Responsabilités</h2>
                        <p>DECKO s'efforce d'assurer l'exactitude des informations présentées sur Decko.fr, mais ne saurait être tenu responsable d'éventuelles erreurs ou omissions.</p>
                    </LegalContent>
                </SectionContainer>
            </Section>
        </LegalPageWrapper>
    );
};

export default MentionsLegales;